// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

<template>
  <div>
    <a-affix :offsetTop="this.$store.getters.shutdownTriggered ? 103 : 50">
      <a-card class="breadcrumb-card" style="z-index: 10">
        <a-row :gutter="[12,12]">
          <a-col :span="device === 'mobile' ? 24 : 12" style="padding-left: 12px; margin-top: 10px">
            <breadcrumb :resource="resource">
              <template #end>
                
              </template>
            </breadcrumb>
          </a-col>
          
          <a-col
          :span="device === 'mobile' ? 24 : 12"
          :style="device === 'mobile' ? { float: 'right', 'margin-top': '12px', 'margin-bottom': '-6px', display: 'table' } : { float: 'right', display: 'table', 'margin-top': '6px' }" >
          
        </a-col>
      </a-row>
    </a-card>
  </a-affix>
  <a-row :gutter="[12,12]" style="padding-bottom:15px;">
    <a-col :span="24">
      <h1 class="onboard-title">{{ $t('label.limits') }}</h1>
      
    </a-col>
    <a-col :span="24">
      <p> {{ $t('label.limits.description') }}</p>
    </a-col>
                </a-row>
  <a-row  >
 
    <a-col :xs="{ span: 24 }" :lg="{ span: 24 }" :xl="{ span: 24 }" :xxl="{ span: 24 }">
      <a-row :gutter="[12,0]">
        
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 3 }" :xxl="{ span: 3 }"  v-if="'listVirtualMachines' in $store.getters.apis">
          <chart-card :loading="loading" class="bordered-card " style="text-align:center;">
            <router-link :to="{ path: '/vm' }">
              <a-statistic
              :title="$t('label.instances')"
              :value="data.running"
              :value-style="{ color: $config.theme['@primary-color'] }">
              <template #prefix>
                <cloud-server-outlined/>&nbsp;
                
              </template>
            </a-statistic>
          </router-link>
          <!-- <div style="text-align: center">
            <status class="status" text="Running"/> {{data.running}}
            <status class="status" text="Stopped"/> {{ data.stopped > 0 ? data.stopped: 0 }}
          </div> -->
        </chart-card>
      </a-col> 
      
      
      
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 3 }" :xxl="{ span: 3 }"  v-if="'listKubernetesClusters' in $store.getters.apis">
        <chart-card :loading="loading" class="bordered-card " style="text-align:center;">
          <router-link :to="{ path: '/kubernetes' }">
            <a-statistic
            :title="$t('label.kubernetes.cluster')"
            :value="data.kubernetes"
            :value-style="{ color: $config.theme['@primary-color'] }">
            <template #prefix>
              <cluster-outlined/>&nbsp;
            </template>
          </a-statistic>
        </router-link>
      </chart-card>
    </a-col> 
    
    
    
    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 3 }" :xxl="{ span: 3 }" v-if="'listVolumes' in $store.getters.apis">
      <chart-card :loading="loading" class="bordered-card " style="text-align:center;">
        <router-link :to="{ path: '/volume' }">
          <a-statistic
          :title="$t('label.volumes')"
          :value="data.volumes"
          :value-style="{ color: $config.theme['@primary-color'] }">
          <template #prefix>
            <hdd-outlined/>&nbsp;
          </template>
        </a-statistic>
      </router-link>
    </chart-card>
  </a-col> 
  
  
  
  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 3 }" :xxl="{ span: 3 }" v-if="'listSnapshots' in $store.getters.apis">
    <chart-card :loading="loading" class="bordered-card " style="text-align:center;">
      <router-link :to="{ path: '/snapshot' }">
        <a-statistic
        :title="$t('label.snapshots')"
        :value="data.snapshots"
        :value-style="{ color: $config.theme['@primary-color'] }">
        <template #prefix>
          <build-outlined/>&nbsp;
        </template>
      </a-statistic>
    </router-link>
  </chart-card>
</a-col> 



<a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 3 }" :xxl="{ span: 3 }" v-if="'listNetworks' in $store.getters.apis">
  <chart-card :loading="loading" class="bordered-card " style="text-align:center;">
    <router-link :to="{ path: '/guestnetwork' }">
      <a-statistic
      :title="$t('label.guest.networks')"
      :value="data.networks"
      :value-style="{ color: $config.theme['@primary-color'] }">
      <template #prefix>
        <apartment-outlined/>&nbsp;
      </template>
    </a-statistic>
  </router-link>
</chart-card>
</a-col> 



<a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 3 }" :xxl="{ span: 3 }" v-if="'listVPCs' in $store.getters.apis">
  <chart-card :loading="loading" class="bordered-card " style="text-align:center;">
    <router-link :to="{ path: '/vpc' }">
      <a-statistic
      :title="$t('label.vpcs')"
      :value="data.vpcs"
      :value-style="{ color: $config.theme['@primary-color'] }">
      <template #prefix>
        <deployment-unit-outlined/>&nbsp;
      </template>
    </a-statistic>
  </router-link>
</chart-card>
</a-col> 



<a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 3 }" :xxl="{ span: 3 }" v-if="'listPublicIpAddresses' in $store.getters.apis">
  <chart-card :loading="loading" class="bordered-card " style="text-align:center;">
    <router-link :to="{ path: '/publicip' }">
      <a-statistic
      :title="$t('label.public.ips')"
      :value="data.ips"
      :value-style="{ color: $config.theme['@primary-color'] }">
      <template #prefix>
        <environment-outlined/>&nbsp;
      </template>
    </a-statistic>
  </router-link>
</chart-card>
</a-col> 

<a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 3 }" :xxl="{ span: 3 }" v-if="'listTemplates' in $store.getters.apis">
  <chart-card :loading="loading" class="bordered-card " style="text-align:center;">
    <router-link :to="{ path: '/template', query: { templatefilter: 'self', filter: 'self' } }">
      <a-statistic
      :title="$t('label.templates')"
      :value="data.templates"
      :value-style="{ color: $config.theme['@primary-color'] }">
      <template #prefix>
        <picture-outlined/>&nbsp;
      </template>
    </a-statistic>
  </router-link>
</chart-card>
</a-col> 
</a-row>
</a-col>

<a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 24 }" :xxl="{ span: 24 }">
  <a-row  :gutter="[12,0]">
    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 6 }" :xxl="{ span: 6 }"
    v-for="usageType in ['vm', 'cpu', 'memory', 'project']"
    :key="usageType" v-if="!project">
    <chart-card :loading="loading" class="bordered-card " style="text-align:center;">
      <div v-if="usageType + 'total' in entity">
        <div>
          <strong>
            {{ $t(getLabel(usageType)) }}
          </strong>
          <span style="float: right">
            {{ getValue(usageType, entity[usageType + 'total']) }} {{ $t('label.used') }}
          </span>
        </div>
        <a-progress
        status="active"
        type="circle"
        :percent="parseFloat(getPercentUsed(entity[usageType + 'total'], entity[usageType + 'limit']))"
        :format="p => entity[usageType + 'limit'] !== '-1' && entity[usageType + 'limit'] !== 'Unlimited' ? p.toFixed(0) + '%' : ''"
        stroke-color="#52c41a"
        size="small"
        />
        <br/>
        <div style="text-align: center">
          {{ entity[usageType + 'available'] === 'Unlimited' ? $t('label.unlimited') : getValue(usageType, entity[usageType + 'available']) }} 
          {{ entity[usageType + 'limit'] === 'Unlimited' ? '' : (' / ' + getValue(usageType, entity[usageType + 'limit']) + ' ' + $t('label.limit')) }}
        </div>
      </div>
    </chart-card>
  </a-col> 
  
  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 6 }" :xxl="{ span: 6 }"
  v-for="usageType in ['volume', 'snapshot', 'template', 'primarystorage', 'secondarystorage']"
  :key="usageType">
  <chart-card :loading="loading" class="bordered-card" style="text-align:center;">
    <div>
      <div>
        <strong>
          {{ $t(getLabel(usageType)) }}
        </strong>
        <span style="float: right">
          {{ getValue(usageType, entity[usageType + 'total']) }} {{ $t('label.used') }}
        </span>
      </div>
      <a-progress
      status="active"
      type="circle"
      :percent="parseFloat(getPercentUsed(entity[usageType + 'total'], entity[usageType + 'limit']))"
      :format="p => entity[usageType + 'limit'] !== '-1' && entity[usageType + 'limit'] !== 'Unlimited' ? p.toFixed(0) + '%' : ''"
      stroke-color="#52c41a"
      size="small"
      />
      <br/>
      <div style="text-align: center">
        {{ entity[usageType + 'available'] === 'Unlimited' ? $t('label.unlimited') : getValue(usageType, entity[usageType + 'available']) }} 
        {{ entity[usageType + 'limit'] === 'Unlimited' ? '' : (' / ' + getValue(usageType, entity[usageType + 'limit']) + ' ' + $t('label.limit')) }}
      </div>
    </div>
  </chart-card>
</a-col> 

<a-col :xs="{ span: 24 }" :lg="{ span: 12 }" :xl="{ span: 6 }" :xxl="{ span: 6 }"
v-for="usageType in ['ip', 'network', 'vpc']"
:key="usageType">
<chart-card :loading="loading" class="bordered-card" style="text-align:center;">
  <div
  >
  <div>
    <div>
      <strong>
        {{ $t(getLabel(usageType)) }}
      </strong>
      <span style="float: right">
        {{ getValue(usageType, entity[usageType + 'total']) }} {{ $t('label.used') }}
      </span>
    </div>
    <a-progress
    status="active"
    type="circle"
    :percent="parseFloat(getPercentUsed(entity[usageType + 'total'], entity[usageType + 'limit']))"
    :format="p => entity[usageType + 'limit'] !== '-1' && entity[usageType + 'limit'] !== 'Unlimited' ? p.toFixed(0) + '%' : ''"
    stroke-color="#52c41a"
    size="small"
    />
    <br/>
    <div style="text-align: center">
      {{ entity[usageType + 'available'] === 'Unlimited' ? $t('label.unlimited') : getValue(usageType, entity[usageType + 'available']) }}
      {{ entity[usageType + 'limit'] === 'Unlimited' ? '' : (' / ' + getValue(usageType, entity[usageType + 'limit']) + ' ' + $t('label.limit')) }}
    </div>
  </div>
</div>
</chart-card>
</a-col> 

</a-row>
</a-col>




</a-row>
</div>
</template>

<script>
import { getAPI } from '@/api'
import store from '@/store'
import { mixinDevice } from '@/utils/mixin.js'
import ChartCard from '@/components/widgets/ChartCard'
import UsageDashboardChart from '@/views/dashboard/UsageDashboardChart'
import ResourceLabel from '@/components/widgets/ResourceLabel'
import Status from '@/components/widgets/Status'
import Breadcrumb from '@/components/widgets/Breadcrumb'

export default {
  name: 'UsageDashboard',
  components: {
    ChartCard,
    UsageDashboardChart,
    ResourceLabel,
    Status,
    Breadcrumb
  },
  props: {
    resource: {
      type: Object,
      default () {
        return {}
      }
    },
    showProject: {
      type: Boolean,
      default: false
    }
  },
  mixins: [mixinDevice],
  data () {
    return {
      loading: false,
      showAction: false,
      showAddAccount: false,
      project: {},
      account: {},
      events: [],
      data: {
        running: 0,
        stopped: 0,
        instances: 0,
        kubernetes: 0,
        volumes: 0,
        snapshots: 0,
        networks: 0,
        vpcs: 0,
        ips: 0,
        templates: 0
      }
    }
  },
  computed: {
    entity: function () {
      if (this.showProject) {
        return this.project
      }
      return this.account
    }
  },
  created () {
    this.project = store.getters.project
    this.fetchData()
    this.$store.watch(
    (state, getters) => getters.project,
    (newValue, oldValue) => {
      if (newValue && newValue.id && (!oldValue || newValue.id !== oldValue.id)) {
        this.fetchData()
      } else if (store.getters.userInfo.roletype !== 'Admin' && !store.getters.logoutFlag) {
        this.fetchData()
      }
    }
    )
  },
  watch: {
    '$route' (to) {
      if (to.name === 'dashboard') {
        this.fetchData()
      }
    },
    resource: {
      deep: true,
      handler (newData, oldData) {
        this.project = newData
        if (newData.id) {
          this.fetchData()
        }
      }
    },
    '$i18n.global.locale' (to, from) {
      if (to !== from) {
        this.fetchData()
      }
    }
  },
  methods: {
    fetchData () {
      if (store.getters.project.id) {
        this.listProject()
      } else {
        this.listAccount()
      }
      this.updateData()
    },
    listAccount () {
      this.loading = true
      getAPI('listAccounts', { id: this.$store.getters.userInfo.accountid }).then(json => {
        this.loading = false
        if (json && json.listaccountsresponse && json.listaccountsresponse.account) {
          this.account = json.listaccountsresponse.account[0]
        }
      })
    },
    listProject () {
      this.loading = true
      getAPI('listProjects', { id: store.getters.project.id }).then(json => {
        this.loading = false
        if (json && json.listprojectsresponse && json.listprojectsresponse.project) {
          this.project = json.listprojectsresponse.project[0]
        }
      })
    },
    updateData () {
      this.data = {
        running: 0,
        stopped: 0,
        instances: 0,
        kubernetes: 0,
        volumes: 0,
        snapshots: 0,
        networks: 0,
        vpcs: 0,
        ips: 0,
        templates: 0
      }
      this.listInstances()
      this.listEvents()
      if ('listKubernetesClusters' in this.$store.getters.apis) {
        this.loading = true
        getAPI('listKubernetesClusters', { listall: true, page: 1, pagesize: 1 }).then(json => {
          this.loading = false
          this.data.kubernetes = json?.listkubernetesclustersresponse?.count
        })
      }
      if ('listVolumes' in this.$store.getters.apis) {
        this.loading = true
        getAPI('listVolumes', { listall: true, page: 1, pagesize: 1 }).then(json => {
          this.loading = false
          this.data.volumes = json?.listvolumesresponse?.count
        })
      }
      if ('listSnapshots' in this.$store.getters.apis) {
        this.loading = true
        getAPI('listSnapshots', { listall: true, page: 1, pagesize: 1 }).then(json => {
          this.loading = false
          this.data.snapshots = json?.listsnapshotsresponse?.count
        })
      }
      if ('listNetworks' in this.$store.getters.apis) {
        this.loading = true
        getAPI('listNetworks', { listall: true, page: 1, pagesize: 1 }).then(json => {
          this.loading = false
          this.data.networks = json?.listnetworksresponse?.count
        })
      }
      if ('listVPCs' in this.$store.getters.apis) {
        this.loading = true
        getAPI('listVPCs', { listall: true, page: 1, pagesize: 1 }).then(json => {
          this.loading = false
          this.data.vpcs = json?.listvpcsresponse?.count
        })
      }
      if ('listPublicIpAddresses' in this.$store.getters.apis) {
        this.loading = true
        getAPI('listPublicIpAddresses', { listall: true, page: 1, pagesize: 1 }).then(json => {
          this.loading = false
          this.data.ips = json?.listpublicipaddressesresponse?.count
        })
      }
      if ('listTemplates' in this.$store.getters.apis) {
        this.loading = true
        getAPI('listTemplates', { templatefilter: 'self', listall: true, page: 1, pagesize: 1 }).then(json => {
          this.loading = false
          this.data.templates = json?.listtemplatesresponse?.count
        })
      }
    },
    listInstances () {
      if (!('listVirtualMachines' in this.$store.getters.apis)) {
        return
      }
      this.loading = true
      getAPI('listVirtualMachines', { listall: true, details: 'min', page: 1, pagesize: 1 }).then(json => {
        this.loading = false
        this.data.instances = json?.listvirtualmachinesresponse?.count
      })
      getAPI('listVirtualMachines', { listall: true, details: 'min', state: 'running', page: 1, pagesize: 1 }).then(json => {
        this.loading = false
        this.data.running = json?.listvirtualmachinesresponse?.count
      })
      getAPI('listVirtualMachines', { listall: true, details: 'min', state: 'stopped', page: 1, pagesize: 1 }).then(json => {
        this.loading = false
        this.data.stopped = json?.listvirtualmachinesresponse?.count
      })
    },
    listEvents () {
      if (!('listEvents' in this.$store.getters.apis)) {
        return
      }
      const params = {
        page: 1,
        pagesize: 8,
        listall: true
      }
      this.loading = true
      getAPI('listEvents', params).then(json => {
        this.events = []
        this.loading = false
        if (json && json.listeventsresponse && json.listeventsresponse.event) {
          this.events = json.listeventsresponse.event
        }
      })
    },
    getLabel (usageType) {
      switch (usageType) {
        case 'vm':
        return 'label.instances'
        case 'cpu':
        return 'label.cpunumber'
        case 'memory':
        return 'label.memory'
        case 'primarystorage':
        return 'label.primary.storage'
        case 'secondarystorage':
        return 'label.secondary.storage'
        case 'ip':
        return 'label.public.ips'
      }
      return 'label.' + usageType + 's'
    },
    getValue (usageType, value) {
      if (value == 0 || value === undefined)
      return '0 GiB';
      switch (usageType) {
        case 'memory':
        return parseFloat(value / 1024.0).toFixed(2) + ' GiB'
        case 'primarystorage':
        return parseFloat(value).toFixed(2) + ' GiB'
        case 'secondarystorage':
        return parseFloat(value).toFixed(2) + ' GiB'
      }
      return value
    },
    getPercentUsed (total, limit) {
      return (limit === 'Unlimited') ? 0 : (total / limit) * 100
    },
    getEventColour (event) {
      if (event.level === 'ERROR') {
        return 'red'
      }
      if (event.state === 'Completed') {
        return 'green'
      }
      return 'blue'
    }
  }
}
</script>

<style lang="less" scoped>
.breadcrumb-card {
  margin-left: -24px;
  margin-right: -24px;
  margin-top: -16px;
  margin-bottom: 12px;
}

.row-element {
  margin-bottom: 10px;
}

.ant-breadcrumb {
  vertical-align: text-bottom;
}

:deep(.ant-switch-inner) {
  display: block;
  font-size: 14px;
  margin: 0px 14px 0px 28px;
}
:deep(.usage-dashboard) {
  
  &-chart-tile {
    margin-bottom: 12px;
  }
  
  &-chart-card {
    padding-top: 24px;
  }
  
  &-chart-card-inner {
    text-align: center;
  }
  
  &-footer {
    padding-top: 12px;
    padding-left: 3px;
    white-space: normal;
  }
}

.dashboard-card {
  width: 100%;
  min-height: 420px;
}

.dashboard-event {
  width: 100%;
  overflow-x:hidden;
  overflow-y: scroll;
  //max-height: 420px;
}

.center {
  display: block;
  text-align: center;
}

@media (max-width: 1200px) {
  .ant-col-xl-8 {
    width: 100%;
  }
}

.ant-col {
  display: flex;
  flex-flow: column;
  padding-bottom: 5px;  
}
.bordered-card {
  border-radius: 5px;
  flex: 1;
}

</style>
